import React from 'react';
import { Alert, Button } from 'antd';
import useFastAssetEligibility from './useFastAssetEligibility';

/** Keep excluded saved IDs removable without silently changing the authored universe. */
export default function FastAssetSelectionNotice({
  eligibility,
  selected,
  onRemove,
  disabled,
}: {
  eligibility: ReturnType<typeof useFastAssetEligibility>;
  selected: number[];
  onRemove: (ids: number[]) => void;
  disabled?: boolean;
}) {
  if (!eligibility.isFast) return null;
  if (eligibility.error)
    return (
      <Alert
        type="error"
        title="Fast engine assets could not be loaded"
        description={eligibility.error}
        action={<Button onClick={eligibility.reload}>Retry</Button>}
      />
    );
  if (eligibility.loading)
    return <Alert type="info" title="Loading eligible fast engine assets…" />;
  const excluded = selected.filter(id => !eligibility.allows(id));
  if (!excluded.length) return null;
  return (
    <Alert
      type="warning"
      title={`${excluded.length} selected instruments are unavailable for this fast blueprint`}
      description="Remove these selections before saving. Only compatible instruments appear in the picker."
      action={
        <Button disabled={disabled} onClick={() => onRemove(excluded)}>
          Remove unavailable selections
        </Button>
      }
    />
  );
}
